import { useTranslation } from 'react-i18next';

export default function Process() {
  const { t } = useTranslation();
  
  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: t('process.step1.title'),
      description: t('process.step1.desc')
    },
    {
      number: '02',
      icon: 'ri-search-eye-line',
      title: t('process.step2.title'),
      description: t('process.step2.desc')
    },
    {
      number: '03',
      icon: 'ri-file-list-3-line',
      title: t('process.step3.title'),
      description: t('process.step3.desc')
    },
    {
      number: '04',
      icon: 'ri-calendar-schedule-line',
      title: t('process.step4.title'),
      description: t('process.step4.desc')
    },
    {
      number: '05',
      icon: 'ri-team-line',
      title: 'Ekip Atama',
      description: 'Tesisinize özel, eğitimli bir temizlik ekibi atanır. Özel gereksinimlerinizi ve tercihlerinizi öğrenirler.'
    },
    {
      number: '06',
      icon: 'ri-checkbox-circle-line',
      title: 'Kaliteli Hizmet',
      description: 'Ekibimiz düzenli kalite kontrolleri ve sürekli iletişimle memnuniyeti sağlamak için tutarlı, yüksek kaliteli temizlik sunar.'
    }
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('process.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-50 rounded-xl p-8 h-full hover:shadow-lg transition-shadow">
                <div className="flex items-start mb-4">
                  <div className="text-6xl font-bold text-teal-100 mr-4">{step.number}</div>
                  <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-teal-600"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Profesyonel Temizlik Deneyimi Yaşamaya Hazır mısınız?
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Ticari temizlik ihtiyaçları için bize güvenen yüzlerce memnun müşteriye katılın. Bugün ücretsiz, yükümlülük gerektirmeyen bir teklif alın ve profesyonel hizmetin farkını keşfedin.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-teal-600 mr-3 text-xl"></i>
                  <span>Ücretsiz yerinde danışmanlık ve değerlendirme</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-teal-600 mr-3 text-xl"></i>
                  <span>Tesisiniz için özelleştirilmiş temizlik planı</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-teal-600 mr-3 text-xl"></i>
                  <span>Gizli maliyet olmayan şeffaf fiyatlandırma</span>
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-teal-600 mr-3 text-xl"></i>
                  <span>İhtiyaçlarınıza uygun esnek programlama</span>
                </li>
              </ul>
              <button className="bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer">
                Şimdi Ücretsiz Teklifinizi Alın
              </button>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/ff5208246b70af1a0148455ada65e531.jpg"
                alt="Profesyonel Danışmanlık"
                className="rounded-xl shadow-2xl object-cover object-top w-full h-96"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
